// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3york","noUnderline":"_3Km6d","heading-secondary":"_1L67m","newFont":"_2gmXe"};